 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"src/components/Dashboard":"src/components/Dashboard","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~88e8db71":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~88e8db71","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab","src/components/categories/index":"src/components/categories/index","src/components/config/permissions":"src/components/config/permissions","src/components/config/roles":"src/components/config/roles","src/components/config/users":"src/components/config/users","src/components/discounts/index":"src/components/discounts/index","src/components/products/index":"src/components/products/index","src/components/receipts/index":"src/components/receipts/index","src/components/reports/sales_category/index":"src/components/reports/sales_category/index","src/components/reports/sales_item/index":"src/components/reports/sales_item/index","src/components/reports/sales_summary/index":"src/components/reports/sales_summary/index","src/components/stores/index":"src/components/stores/index","src/components/taxes/index":"src/components/taxes/index","src/components/views/Pos":"src/components/views/Pos","src/components/views/Login":"src/components/views/Login","src/components/views/Signup":"src/components/views/Signup","src/components/views/forgotpassword":"src/components/views/forgotpassword","src/components/views/resetpassword":"src/components/views/resetpassword","src/components/profile/index":"src/components/profile/index"}[chunkId]||chunkId) + "." + {"src/components/Dashboard":"f2c56d2c","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174":"0e41ea1f","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~88e8db71":"c86007d1","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7":"be0cd513","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab":"ba491e1f","src/components/categories/index":"eb125299","src/components/config/permissions":"2ff3d140","src/components/config/roles":"5a93fe84","src/components/config/users":"006aa707","src/components/discounts/index":"05f0368c","src/components/products/index":"add562d1","src/components/receipts/index":"2e327420","src/components/reports/sales_category/index":"92f12dc3","src/components/reports/sales_item/index":"658c76c3","src/components/reports/sales_summary/index":"53bfaea7","src/components/stores/index":"2ae130e4","src/components/taxes/index":"a0479f1f","src/components/views/Pos":"a688aa1b","src/components/views/Login":"894114db","src/components/views/Signup":"8cc4e30d","src/components/views/forgotpassword":"1b1918ed","src/components/views/resetpassword":"88469c5d","src/components/profile/index":"8eeef642"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"src/components/Dashboard":1,"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174":1,"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7":1,"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab":1,"src/components/categories/index":1,"src/components/config/roles":1,"src/components/config/users":1,"src/components/products/index":1,"src/components/receipts/index":1,"src/components/reports/sales_category/index":1,"src/components/reports/sales_item/index":1,"src/components/reports/sales_summary/index":1,"src/components/stores/index":1,"src/components/taxes/index":1,"src/components/views/Pos":1,"src/components/views/Login":1,"src/components/views/Signup":1,"src/components/views/forgotpassword":1,"src/components/views/resetpassword":1,"src/components/profile/index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"src/components/Dashboard":"src/components/Dashboard","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~88e8db71":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~88e8db71","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab":"src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab","src/components/categories/index":"src/components/categories/index","src/components/config/permissions":"src/components/config/permissions","src/components/config/roles":"src/components/config/roles","src/components/config/users":"src/components/config/users","src/components/discounts/index":"src/components/discounts/index","src/components/products/index":"src/components/products/index","src/components/receipts/index":"src/components/receipts/index","src/components/reports/sales_category/index":"src/components/reports/sales_category/index","src/components/reports/sales_item/index":"src/components/reports/sales_item/index","src/components/reports/sales_summary/index":"src/components/reports/sales_summary/index","src/components/stores/index":"src/components/stores/index","src/components/taxes/index":"src/components/taxes/index","src/components/views/Pos":"src/components/views/Pos","src/components/views/Login":"src/components/views/Login","src/components/views/Signup":"src/components/views/Signup","src/components/views/forgotpassword":"src/components/views/forgotpassword","src/components/views/resetpassword":"src/components/views/resetpassword","src/components/profile/index":"src/components/profile/index"}[chunkId]||chunkId) + "." + {"src/components/Dashboard":"f4eaa030","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~5f6d2174":"21548975","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~88e8db71":"31d6cfe0","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~1f1990c7":"568f8dfd","src/components/categories/index~src/components/config/permissions~src/components/config/roles~src/co~2c1381ab":"ff3547c7","src/components/categories/index":"0ef143be","src/components/config/permissions":"31d6cfe0","src/components/config/roles":"25b98dba","src/components/config/users":"3658b962","src/components/discounts/index":"31d6cfe0","src/components/products/index":"076e2e03","src/components/receipts/index":"b2c091a0","src/components/reports/sales_category/index":"ad93d396","src/components/reports/sales_item/index":"894fe794","src/components/reports/sales_summary/index":"73d31ee2","src/components/stores/index":"a2e7e3f2","src/components/taxes/index":"3658b962","src/components/views/Pos":"8d67f863","src/components/views/Login":"a85829fa","src/components/views/Signup":"7e2adf72","src/components/views/forgotpassword":"b35da7bf","src/components/views/resetpassword":"3989887f","src/components/profile/index":"23c264ee"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
